/* eslint-disable camelcase */

export interface FetchedData<T> {
  data: T;
}

export interface FetchedList<T> {
  data: T[];
  paging: {
    current_page: number;
    per_page: number;
    total: number;
  };
}

export default class FetchError extends Error {
  status: number;

  code?: number;

  constructor(status: number, message?: string, code?: number) {
    super(message || "Unkown error");
    this.name = "FetchError";
    this.code = code;
    this.status = status;
  }
}
